import React from 'react'
import { DatePickerContext } from './date-picker-root'
import { OverrideComponentProps } from '../utils/overridable-component-helper'
import { composeEventHandlers } from '../utils/compose-event-handlers'

export type DatePickerNextProps<Tag extends React.ElementType<any>> = OverrideComponentProps<Tag>

export const DatePickerNext = React.forwardRef<HTMLDivElement, DatePickerNextProps<any>>(
  ({ as = 'button', ...props }, ref) => {
    const context = React.useContext(DatePickerContext)
    if (!context) {
      throw new Error('Cannot find date picker context')
    } else {
      return React.createElement(as, {
        ...props,
        ref: ref,
        onClick: composeEventHandlers(props.onClick, context.goToNextMonth)
      })
    }
  }
) as WithForwardRefType

DatePickerNext.displayName = 'DatePickerNext'

interface WithForwardRefType extends React.FC<DatePickerNextProps<React.ElementType<any>>> {
  <T extends React.ElementType<any> = 'button'>(props: DatePickerNextProps<T>): ReturnType<React.FC<DatePickerNextProps<T>>>
}
